import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AnimationService } from 'src/app/utils/animation.service';

@Component({
  selector: 'app-skills-invitation',
  templateUrl: './skills-invitation.component.html',
  styleUrls: ['../home.component.scss', './skills-invitation.component.scss']
})
export class InvitationComponent implements OnInit {

  @ViewChild('animation')
  animation: ElementRef;

  constructor(private animations: AnimationService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.fragment.subscribe(params => {
      if (params === 'requirements') {
        const element = document.querySelector('#requirements');
        const headerHeight = document.getElementById('header').offsetHeight;
        if (element) {
          setTimeout(()=>{
            window.scrollTo({
              behavior: 'smooth',
              top: document.getElementById('requirements').offsetTop - headerHeight - 30
            });
          }, 500);
        }
      }
    });
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event) {
    this.animations.startRightToLeftAnimation(this.animation.nativeElement);
  }
}
